export enum ContactsActionTypes {
    API_RESPONSE_SUCCESS = '@@contacts/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@contacts/API_RESPONSE_ERROR',

    GET_CONTACTS = '@@contacts/GET_CONTACTS',
    RESET_CONTACTS = '@@contacts/RESET_CONTACTS',
    CREATE_CONTACT = '@@contacts/CREATE_CONTACT',
    EDIT_CONTACT = '@@contacts/EDIT_CONTACT',
    DELETE_CONTACT = '@@contacts/DELETE_CONTACT',

    UPDATE_SEARCH = '@@contacts/UPDATE_SEARCH',
    UPDATE_CURRENT_PAGE = '@@contacts/UPDATE_CURRENT_PAGE'
}
export interface ContactsState {
    contacts: Array<any>;
    hasMoreContacts: boolean;
    error: boolean;
    search: string;
    currentPage: number;
}
